module.exports = __webpack_public_path__ + "static/media/latam.04ddfc19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/latam.png
// module id = 1289
// module chunks = 0